export default "__VITE_ASSET__DmaxNFIX__"